var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03034 3.99998C6.03034 4.09298 5.99479 4.18607 5.92379 4.25707L2.28744 7.89343C2.14535 8.03552 1.91525 8.03552 1.77326 7.89343C1.63126 7.75134 1.63116 7.52125 1.77326 7.37925L5.15252 3.99998L1.77325 0.620715C1.63116 0.478624 1.63116 0.248533 1.77325 0.106533C1.91535 -0.0354672 2.14544 -0.0355578 2.28744 0.106533L5.92379 3.74289C5.99479 3.81389 6.03034 3.90698 6.03034 3.99998Z",
    fill: "#4F4F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.664374d188157a3a4970c8d50fbb195c.svg";
export { ForwardRef as ReactComponent };